import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupLaboratoryContractByTrialGroupLaboratoryId: ITrialGroupLaboratoryContractLoadByTrialGroupLaboratoryIdActionCreator = (trialGroupLaboratoryId) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_TRIAL_GROUP_LABORATORY_ID,
            trialGroupLaboratoryId
        }
    },
    LoadTrialGroupLaboratoryContractById: ITrialGroupLaboratoryContractLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialGroupLaboratoryContractLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupLaboratoryContractLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialGroupLaboratoryContract: ITrialGroupLaboratoryContractSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialGroupLaboratoryContractSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialGroupLaboratoryContractSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialGroupLaboratoryContract: ITrialGroupLaboratoryContractValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialGroupLaboratoryContractValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialGroupLaboratoryContractValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialGroupLaboratoryContract: ITrialGroupLaboratoryContractCreateActionCreator = (trialGroupLaboratoryId) => {

        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE,
            trialGroupLaboratoryId
        }
    },
    CreateSuccess: ITrialGroupLaboratoryContractCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialGroupLaboratoryContractCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteTrialGroupLaboratoryContract: ITrialGroupLaboratoryContractDeleteActionCreator = (id) => {
    
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE,
            id
        }
    },
    DeleteSuccess: ITrialGroupLaboratoryContractDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE_SUCCESS
        }
    },
    DeleteFailure: ITrialGroupLaboratoryContractDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupLaboratoryContractClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialGroupLaboratoryContractFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYCONTRACT_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_TRIAL_GROUP_LABORATORY_ID = "ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_TRIAL_GROUP_LABORATORY_ID",
    ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_ID = "ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_ID",
    ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_SUCCESS = "ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_SUCCESS",
    ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_FAILURE = "ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_FAILURE",

    ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE = "ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE",
    ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE_SUCCESS = "ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE_FAILURE = "ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE_FAILURE",

    ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE = "ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE",
    ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE_SUCCESS = "ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE_FAILURE = "ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE_FAILURE",

    ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE = "ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE",
    ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE_SUCCESS = "ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE_FAILURE = "ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE_FAILURE",

    ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE = "ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE",
    ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE_SUCCESS = "ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE_FAILURE = "ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE_FAILURE",

    ACTION_TRIALGROUPLABORATORYCONTRACT_CLEAR = "ACTION_TRIALGROUPLABORATORYCONTRACT_CLEAR",

    ACTION_TRIALGROUPLABORATORYCONTRACT_FILTER = "ACTION_TRIALGROUPLABORATORYCONTRACT_FILTER";

export interface ITrialGroupLaboratoryContractLoadByTrialGroupLaboratoryIdAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_TRIAL_GROUP_LABORATORY_ID";
    trialGroupLaboratoryId: number;
}

export interface ITrialGroupLaboratoryContractLoadByTrialGroupLaboratoryIdActionCreator {
    (trialGroupLaboratoryId: number): ITrialGroupLaboratoryContractLoadByTrialGroupLaboratoryIdAction;
}

export interface ITrialGroupLaboratoryContractLoadSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryContract | Dtos.TrialGroupLaboratoryContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryContractLoadSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryContract | Dtos.TrialGroupLaboratoryContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryContractLoadSuccessAction;
}

export interface ITrialGroupLaboratoryContractLoadFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryContractLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryContractLoadFailureAction;
}

export interface ITrialGroupLaboratoryContractLoadByIdAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_ID";
    id: number;
}

export interface ITrialGroupLaboratoryContractLoadByIdActionCreator {
    (id: number): ITrialGroupLaboratoryContractLoadByIdAction;
}

export interface ITrialGroupLaboratoryContractSaveAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE";
    formData: Dtos.TrialGroupLaboratoryContract;

}

export interface ITrialGroupLaboratoryContractSaveActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryContract
    ): ITrialGroupLaboratoryContractSaveAction;
}

export interface ITrialGroupLaboratoryContractSaveSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryContractSaveSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryContractSaveSuccessAction;
}

export interface ITrialGroupLaboratoryContractSaveFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryContractSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryContractSaveFailureAction;
}

export interface ITrialGroupLaboratoryContractValidateAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE";
    formData: Dtos.TrialGroupLaboratoryContract;

}

export interface ITrialGroupLaboratoryContractValidateActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryContract
    ): ITrialGroupLaboratoryContractValidateAction;
}

export interface ITrialGroupLaboratoryContractValidateSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryContractValidateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryContractValidateSuccessAction;
}

export interface ITrialGroupLaboratoryContractValidateFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryContractValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryContractValidateFailureAction;
}

export interface ITrialGroupLaboratoryContractCreateAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE",
    trialGroupLaboratoryId: number
}

export interface ITrialGroupLaboratoryContractCreateActionCreator {
    (trialGroupLaboratoryId: number): ITrialGroupLaboratoryContractCreateAction
}

export interface ITrialGroupLaboratoryContractCreateSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryContract;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialGroupLaboratoryContractCreateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryContract,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialGroupLaboratoryContractCreateSuccessAction;
}

export interface ITrialGroupLaboratoryContractCreateFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryContractCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryContractCreateFailureAction;
}

export interface ITrialGroupLaboratoryContractDeleteAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE";
    id: number;
}

export interface ITrialGroupLaboratoryContractDeleteActionCreator {
    (id: number): ITrialGroupLaboratoryContractDeleteAction
}

export interface ITrialGroupLaboratoryContractDeleteSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE_SUCCESS";
}

export interface ITrialGroupLaboratoryContractDeleteSuccessActionCreator {
    (): ITrialGroupLaboratoryContractDeleteSuccessAction;
}

export interface ITrialGroupLaboratoryContractDeleteFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryContractDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryContractDeleteFailureAction;
}

export interface ITrialGroupLaboratoryContractClearAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupLaboratoryContractClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupLaboratoryContractClearAction;
}

export interface ITrialGroupLaboratoryContractFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupLaboratoryContractFilterAction;
}

export interface ITrialGroupLaboratoryContractFilterAction {
    type: "ACTION_TRIALGROUPLABORATORYCONTRACT_FILTER";
    formFilter: IFormFilter;
}

export type TrialGroupLaboratoryContractAction =
    ITrialGroupLaboratoryContractLoadByTrialGroupLaboratoryIdAction |
    ITrialGroupLaboratoryContractLoadByIdAction |
    ITrialGroupLaboratoryContractLoadFailureAction |
    ITrialGroupLaboratoryContractLoadSuccessAction |
    ITrialGroupLaboratoryContractSaveAction |
    ITrialGroupLaboratoryContractSaveSuccessAction |
    ITrialGroupLaboratoryContractSaveFailureAction |
    ITrialGroupLaboratoryContractValidateAction |
    ITrialGroupLaboratoryContractValidateSuccessAction |
    ITrialGroupLaboratoryContractValidateFailureAction |
    ITrialGroupLaboratoryContractCreateAction |
    ITrialGroupLaboratoryContractCreateSuccessAction |
    ITrialGroupLaboratoryContractCreateFailureAction |
    ITrialGroupLaboratoryContractDeleteAction |
    ITrialGroupLaboratoryContractDeleteSuccessAction |
    ITrialGroupLaboratoryContractDeleteFailureAction |
    ITrialGroupLaboratoryContractClearAction | 
    ITrialGroupLaboratoryContractFilterAction;
